import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { IPropretyAttribute, IEntityMetaData } from "../../_models/IEntityMetaData";
import { PropretyAttributes, Validation, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { FSTREAM_Image } from "./FSTREAM_Image.model";
import { i18nLanguage } from "./i18nLanguage.model";
import { Tenant } from "./Tenant.model";
import { AccessCard } from "./AccessCard.model";
import { BuzzerConfig } from "./BuzzerConfig.model";
import { Covid } from "./Covid.model";
import { Delivery } from "./Delivery.model";
import { Dock } from "./Dock.model";
import { EmployeePresenceInstance } from "./EmployeePresenceInstance.model";
import { EmployeePresenceTemplate } from "./EmployeePresenceTemplate.model";
import { Face } from "./Face.model";
import { Feedback } from "./Feedback.model";
import { Form } from "./Form.model";
import { PreVisit } from "./PreVisit.model";
import { Quiz } from "./Quiz.model";
import { Room } from "./Room.model";
import { RoomReservationInstance } from "./RoomReservationInstance.model";
import { Trucker } from "./Trucker.model";
import { TruckerActivity } from "./TruckerActivity.model";
import { Visit } from "./Visit.model";
import { Account_POS_Admin } from "./navigation-entities/Account_POS_Admin.model";
import { Account_POS_Employee } from "./navigation-entities/Account_POS_Employee.model";
import { Account_POS_Login } from "./navigation-entities/Account_POS_Login.model";
import { Account_POS_ReadOnly } from "./navigation-entities/Account_POS_ReadOnly.model";
import { Employee_POS } from "./navigation-entities/Employee_POS.model";
import { i18nPosTranslationOverride } from "./navigation-entities/i18nPosTranslationOverride.model";
import { RegexType } from "../../services/RegexPatternLibrary";
import { Account } from "./Account.model";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";
import { Employee } from "./Employee.model";
import { Policy } from "./Policy.model";
import { Engagement } from "./Engagement.model";
import { Translation } from "./navigation-entities/Translation.model";


@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'PointOfService' // optionnel car par defaut utilise le nom de classe
})
export class PointOfService extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  @Validation({
    propertyType: `${RegexType.Alphanumeric}|${RegexType.WithSpecialChars}`,
    minLength: 2,
    maxLength: 50
  })
  name!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.CivicNumberCA}`,
    minLength: 2,
    maxLength: 50
  })
  civicNumber!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Street}`,
    minLength: 2,
    maxLength: 50
  })
  street!: string;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.OfficeNumber}`,
    minLength: 2,
    maxLength: 50
  })
  officeNumber?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.City}`,
    minLength: 2,
    maxLength: 50
  })
  city!: string;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.StateOrProvince}`,
    minLength: 2,
    maxLength: 50
  })
  state?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Country}`,
    minLength: 2,
    maxLength: 50
  })
  country!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.PostalCodeCA}|${RegexType.PostalCodeUS}`
  })
  postalCode!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  @Validation({
    propertyType: `${RegexType.Url}|${RegexType.WithSpecialChars}`,
    minLength: 2,
    maxLength: 50
  })
  prefix!: string;

  @PropretyAttributes({})
  hTML?: string;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Url}|${RegexType.WithSpecialChars}`,
    minLength: 2,
    maxLength: 50
  })
  urlAddressPrinter?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  printBadge: boolean = false;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 0,
    maxLength: 200
  })
  printerBrightness?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 1,
    maxLength: 200
  })
  cameraZoom!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 1,
    maxLength: 200
  })
  cameraTimeout!: number;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 1,
    maxLength: 3
  })
  printerLabelType?: number;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 1,
    maxLength: 200
  })
  printerLabelSize?: number;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Alphanumeric}|${RegexType.WithSpecialChars}`,
    minLength: 1,
    maxLength: 200
  })
  wIFI_Name?: string;

  @PropretyAttributes({})
  wIFI_Account?: string;

  @PropretyAttributes({})
  wIFI_Password?: string;

  @PropretyAttributes({})
  welcomeMessageTitle?: string;

  @PropretyAttributes({})
  welcommeMessageDescription?: string;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 0,
    maxLength: 200
  })
  signoutField?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewVisitor_MultipleHost: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewVisitor_Camera: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewVisitor_Signature: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewVisitor: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_HaveBeenHereBefore: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Delivery: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_EmployeeOnly: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Employee: boolean = false;

  @PropretyAttributes({})
  fK_Image_Logo?: number;

  @PropretyAttributes({})
  fK_Image_Badge?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_Tenant!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 1,
    maxLength: 30
  })
  fK_i18nLanguage!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_MultipleVisitors: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Visitor_Skip_Signature: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Contractor: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Contractor_Skip_Signature: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewVisitor_Covid: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Contractor_Covid: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewVisitor_CompanyRequired: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewEmployee_Notify_Manager: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewEmployee_Sign_Legal_Document: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewEmployee_Covid: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewEmployee_Signature: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewEmployee_Camera: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewEmployee_PrintBadge: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_WRInstance_CovidAlert: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_ReturningEmployee_Sign_Legal_Document_Yearly: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_ReturningEmployee_Skip_Signature: boolean = false;

  //@PropretyAttributes({})
  //@Validation({
  //  propertyType: `${RegexType.Alphanumeric}|${RegexType.WithSpecialChars}`,
  //  minLength: 1,
  //  maxLength: 40
  //})
  slackToken?: string;

  //@PropretyAttributes({})
  //@Validation({
  //  propertyType: `${RegexType.Alphanumeric}|${RegexType.WithSpecialChars}`,
  //  minLength: 1,
  //  maxLength: 40
  //})
  teamsBotId?: string;

  //@PropretyAttributes({})
  //@Validation({
  //  propertyType: `${RegexType.Alphanumeric}|${RegexType.WithSpecialChars}`,
  //  minLength: 0,
  //  maxLength: 500
  //})
  teamsBotSecret?: string;

  //@PropretyAttributes({})
  //@Validation({
  //  propertyType: `${RegexType.Url}|${RegexType.WithSpecialChars}`,
  //  minLength: 1,
  //  maxLength: 40
  //})
  teamsServiceUrl?: string;

  //@PropretyAttributes({})
  //@Validation({
  //  propertyType: `${RegexType.Alphanumeric}|${RegexType.WithSpecialChars}`,
  //  minLength: 1,
  //  maxLength: 40
  //})
  teamsTenantId?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 1,
    maxLength: 3
  })
  smsProvider!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 1,
    maxLength: 139
  })
  timeZone!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 0,
    maxLength: 365
  })
  visitorHistoryDays!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 0,
    maxLength: 2
  })
  automaticCheckOut!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 1,
    maxLength: 200
  })
  automaticCheckOutHour?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Contractor_Enforce_Document_Signature: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 0,
    maxLength: 365
  })
  dS_Contractor_Sign_Legal_Document_Days!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_WorkspaceReservation: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_ShowQrCode: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  printCompany: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  printName: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @PropretyAttributes({})
  dS_Checkout_Feedbacks: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_SleepScreen: boolean = false;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 0,
    maxLength: 23
  })
  dS_SleepStartHour?: number;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 0,
    maxLength: 23
  })
  dS_SleepEndHour?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_ShowBuzzer: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  defaultPOS: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Visitor_Quiz: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Contractor_Quiz: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Employee_Quiz: boolean = false;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 1,
    maxLength: 60000
  })
  quiz_NbQuestion?: number;

  @PropretyAttributes({})
  quiz_Random?: boolean;

  @PropretyAttributes({})
  quiz_Title?: string;

  @PropretyAttributes({})
  quiz_TitleDescription?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  serviceUnavailable: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_FireAlert: boolean = false;

  @PropretyAttributes({})
  fireAlert_Email_Subject?: string;

  @PropretyAttributes({})
  fireAlert_Email_Body?: string;

  @PropretyAttributes({})
  fireAlert_SMS?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 0,
    maxLength: 23
  })
  reportStartHour!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewVisitor_ShowPhoneNumber: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewContractor_ShowPhoneNumber: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Employee_QrCodeScanner: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Employee_QrCodeGenerator: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Visitor_QrCodeScanner: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Contractor_QrCodeScanner: boolean = false;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 0,
    maxLength: 365
  })
  quizFrequency?: number;

  @PropretyAttributes({})
  quizTemplateDate?: Date;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  automaticAssignAccessCard: boolean = false;

  @PropretyAttributes({})
  policiesTemplateDate?: Date;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 0,
    maxLength: 365
  })
  policiesFrequency?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 1,
    maxLength: 200
  })
  notificationTimeOut!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 1,
    maxLength: 200
  })
  notificationSize!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  employeeQuizAttachment: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  employeeVisitorPoliciesAttachment: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  employeeContractorPoliciesAttachment: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  employeeCovidAttachment: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_RefreshTime!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({
    propertyType: `${RegexType.Alphanumeric}|${RegexType.WithSpecialChars}`,
    minLength: 1,
    maxLength: 200
  })
  emailSettingFrom!: string;

  @PropretyAttributes({})
  fK_Trucker_Responsibles?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Trucker_QrCodeScanner: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  feature_Visit: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  feature_Trucker: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Trucker_AutomaticAssignDock: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Trucker_EmailMandatory: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_Trucker_PhoneNumberMandatory: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_NewEmployee_QrCode: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  dS_FaceRecognition: boolean = false;

  @PropretyAttributes({})
  truckerPoliciesTemplateDate?: Date;

  @PropretyAttributes({})
  @Validation({
    propertyType: `${RegexType.Numeric}`,
    minLength: 0,
    maxLength: 365
  })
  truckerPoliciesFrequency?: number;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageLogo?: FSTREAM_Image;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageBadge?: FSTREAM_Image;

  @NestedProperty({ TargetType: Tenant })
  tenant?: Tenant;

  sourceTenantDTO?: any; // DTO de transfert 

  @NestedProperty({ TargetType: i18nLanguage })
  i18nLanguage?: i18nLanguage;

  @NavigationProperty({ TargetType: AccessCard })
  accessCards?: AccessCard[];

  @NavigationProperty({ TargetType: Account_POS_Admin })
  accountPOSAdmins?: Account_POS_Admin[];

  @NavigationProperty({ TargetType: Account_POS_Employee })
  accountPOSEmployees?: Account_POS_Employee[];

  @NavigationProperty({ TargetType: Account_POS_Login })
  accountPOSLogins?: Account_POS_Login[];

  @NavigationProperty({ TargetType: Account_POS_ReadOnly })
  accountPOSReadOnlys?: Account_POS_ReadOnly[];

  @NavigationProperty({ TargetType: BuzzerConfig })
  buzzerConfigs?: BuzzerConfig[];

  @NavigationProperty({ TargetType: Covid })
  covids?: Covid[];

  @NavigationProperty({ TargetType: Delivery })
  deliveries?: Delivery[];

  @NavigationProperty({ TargetType: Dock })
  docks?: Dock[];

  @NavigationProperty({ TargetType: Employee_POS })
  employeePOS?: Employee_POS[];

  @NavigationProperty({ TargetType: EmployeePresenceInstance })
  employeePresenceInstances?: EmployeePresenceInstance[];

  @NavigationProperty({ TargetType: EmployeePresenceTemplate })
  employeePresenceTemplates?: EmployeePresenceTemplate[];

  @NavigationProperty({ TargetType: Event })
  events?: Event[];

  @NavigationProperty({ TargetType: Face })
  faces?: Face[];

  @NavigationProperty({ TargetType: Feedback })
  feedbacks?: Feedback[];

  @NavigationProperty({ TargetType: Form })
  forms?: Form[];

  @NavigationProperty({ TargetType: i18nPosTranslationOverride })
  i18nPosTranslationOverrides?: i18nPosTranslationOverride[];

  @NavigationProperty({ TargetType: PreVisit })
  preVisits?: PreVisit[];

  @NavigationProperty({ TargetType: Quiz })
  quizzes?: Quiz[];

  @NavigationProperty({ TargetType: Room })
  rooms?: Room[];

  @NavigationProperty({ TargetType: RoomReservationInstance })
  roomReservationInstances?: RoomReservationInstance[];

  @NavigationProperty({ TargetType: Trucker })
  truckers?: Trucker[];

  @NavigationProperty({ TargetType: TruckerActivity })
  truckerActivities?: TruckerActivity[];

  @NavigationProperty({ TargetType: Visit })
  visits?: Visit[];

  @NavigationProperty({ TargetType: Account })
  accounts?: Account[];

  @NavigationProperty({ TargetType: Employee })
  employees?: Employee[];

  truckerResponsibles?: number[];

  @NavigationProperty({ TargetType: Account })
  truckerResponsibleAccounts?: Account[];

  @PropretyAttributes({})
  badgeTemplate?: string;

  @NavigationProperty({ TargetType: Policy })
  policies?: Policy[];

  @NavigationProperty({ TargetType: Engagement })
  engagements?: Engagement[];

  // Traductions des messages d'alerte d'evacuation (relation FIREALERT_{id})
  fireAlertTranslations?: Translation[];

  GetType(): IEntityMetaData {
    return PointOfService.getMetaData();
  }
}
